import React, { Component } from "react";
import { ToastContainer, toast, Zoom } from "react-toastify";
import classNames from "classnames";
import "react-toastify/dist/ReactToastify.css";
import styles from "./Toast.scss";

class Toast extends Component {
  constructor(props) {
    super(props);
    this.renderToast = this.renderToast.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  renderToast({ closeToast }) {
    return (
      <div className={styles.toastContent}>
        <div className={styles.title}>{this.props.title}</div>
        <div className={styles.divider} />
        <div className={styles.content}>{this.props.content}</div>
        <button className={styles.button} onClick={closeToast}>
          Got It
        </button>
      </div>
    );
  }

  showToast(onToastClose) {
    var className = classNames(styles.toastContainer);
    var bodyClassName = classNames(styles.toastBody);

    toast(this.renderToast, {
      className: className,
      bodyClassName: bodyClassName,
      onClose: onToastClose
    });
  }

  render() {
    return (
      <ToastContainer
        autoClose={5000}
        closeButton={false}
        transition={Zoom}
        draggable={false}
        hideProgressBar={true}
        pauseOnHover={false}
        closeOnClick={false}
        newestOnTop={true}
      />
    );
  }
}

export default Toast;



// WEBPACK FOOTER //
// ./src/components/common/toast/Toast.js